<template>
    <div class="dodel-categories">
        <div class="dodel-page-header">
            <router-link :to="{name: 'cart'}" v-if="!is_cart_empty"> 
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"/></svg> {{translate('View your items')}}
            </router-link>
            <div class="dodel-screen-title">
                {{translate('Select from the following product categories')}}
            </div>
        </div>
        <div class="dodel-menu-items">
            <div v-for="(item, index) in menu" :key="item.term_id" class="dodel-menu-item" :class="'dodel-menu-item-'+index">
                <router-link :to="{name: 'category', params: {id: item.term_id}}">
                    <img :src="item.thumbnail" :alt="item.name">
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'categories',
    computed:{
        menu(){
            return this.$store.state.menu
        },
        is_cart_empty(){
            return this.$store.state.cart.length==0
        }
    },
    methods: {
        translate(string){
            return this.$store.state.language[string]
        }
    }
}
</script>